var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSelectedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,2.4140625C30,1.0830078,28.9169922,0,27.5859375,0H4.4140625C3.0830078,0,2,1.0830078,2,2.4140625 C2,3.0498047,2.2578125,3.671875,2.7070312,4.1210938l9.4140625,9.4140625C12.6875,14.1015625,13,14.8554688,13,15.6572266V27 c0,0.265625,0.1054688,0.5195312,0.2929688,0.7070312l4,4C17.484375,31.8984375,17.7402344,32,18,32 c0.1289062,0,0.2587891-0.0244141,0.3828125-0.0761719C18.7568359,31.7695312,19,31.4042969,19,31V15.6572266 c0-0.8017578,0.3125-1.5556641,0.8789062-2.1220703l9.4140625-9.4140625C29.7421875,3.671875,30,3.0498047,30,2.4140625z  M27.8789062,2.7070312l-9.4140625,9.4140625C17.5205078,13.0654297,17,14.3212891,17,15.6572266v12.9287109l-2-2V15.6572266 c0-1.3359375-0.5205078-2.5917969-1.4648438-3.5361328L4.1210938,2.7070312C4.0439453,2.6298828,4,2.5234375,4,2.4140625 C4,2.1855469,4.1855469,2,4.4140625,2h23.171875C27.8144531,2,28,2.1855469,28,2.4140625 C28,2.5234375,27.9560547,2.6298828,27.8789062,2.7070312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,22c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S28.2060547,22,26,22z M26,28 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S27.1025391,28,26,28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSelectedSmall);
export default __webpack_public_path__ + "static/media/filter-selected--small.88799f1b41332ebeb747a384d4009800.svg";
export { ForwardRef as ReactComponent };